import React, { useState } from 'react';
import signupImage from '../../assets/images/signup.jpeg';
import marshalLogo from '../../assets/images/marshal-logo.jpeg';
import './Signupmodal.css';

const SignupModal = ({ isOpen, onClose, onSwitchToLogin }) => {
  const [authType, setAuthType] = useState('email');
  const [formData, setFormData] = useState({ businessName: '', username: '', email: '', phone: '', password: '', confirmPassword: '', termsAgreed: false });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (authType === 'email') {
      if (!formData.email) newErrors.email = 'Email is required';
      else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    } else {
      if (!formData.phone) newErrors.phone = 'Phone number is required';
    }
    if (!formData.password) newErrors.password = 'Password is required';
    else if (formData.password.length < 8) newErrors.password = 'Password must be at least 8 characters';
    if (!formData.confirmPassword) newErrors.confirmPassword = 'Please confirm your password';
    else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
    if (!formData.username && !formData.businessName) {
      newErrors.username = 'Please provide a username or business name';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
      alert('Signup submitted (UI only - connect your backend here)');
    }, 1000);
  };

  if (!isOpen) return null;

  return (
    <div className="signup-modal-overlay" onClick={onClose}>
      <div
        className="signup-modal-container auth-modal"
        onClick={e => e.stopPropagation()}
        style={{ '--modal-bg-image': `url(${signupImage})` }}
      >
        <button className="modal-close-btn" onClick={onClose} aria-label="Close">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>

        {/* Left - Form */}
        <div className="modal-form-section">
          <div className="form-content">
            <div className="auth-modal-header text-center" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
              <div className="modal-logo" style={{ marginBottom: '0', width: '100%', display: 'flex', justifyContent: 'center' }}>
                <img src={marshalLogo} alt="Logo" className="modal-logo-image" style={{ width: '80px', maxWidth: '100%', height: 'auto', objectFit: 'contain', backgroundColor: 'transparent', display: 'block', margin: '0 auto' }} />
              </div>
              <hr style={{ border: 'none', borderTop: '2px solid #e0e0e0', margin: '15px 0', width: '100%' }} />
              <h2 style={{ marginTop: '0', marginBottom: '15px', fontSize: '22px', fontWeight: '600', width: '100%', textAlign: 'center' }}>HMS Portal</h2>
            </div>

            <div className="auth-toggle">
              <button className="toggle-btn active">Sign Up</button>
              <button className="toggle-btn" onClick={onSwitchToLogin}>Log In</button>
            </div>

            <div className="form-main">
              <h2 className="form-title">Create Your Account</h2>
              <p className="form-subtitle">Join HMS Platform today</p>

              <div className="social-buttons">
                <button type="button" className="social-btn">
                  <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" alt="Google" width="18" height="18" />
                  <span style={{ marginLeft: '10px', fontSize: '14px', fontWeight: '500', color: '#1a1a1a' }}>Sign up with Google</span>
                </button>
              </div>

              <div className="divider"><span>or continue with email</span></div>

              {errors.general && <div className="error-message">{errors.general}</div>}

              <form onSubmit={handleSubmit} className="signup-form">
                <div style={{ display: 'flex', gap: '10px', marginBottom: '20px', borderBottom: '2px solid #e0e0e0', paddingBottom: '10px' }}>
                  <button type="button" onClick={() => setAuthType('email')} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'email' ? '#7c3aed' : '#f3f4f6', color: authType === 'email' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>
                    Email
                  </button>
                  <button type="button" onClick={() => setAuthType('phone')} style={{ flex: 1, padding: '10px', border: 'none', background: authType === 'phone' ? '#7c3aed' : '#f3f4f6', color: authType === 'phone' ? 'white' : '#6b7280', borderRadius: '6px', cursor: 'pointer', fontWeight: '500' }}>
                    Phone
                  </button>
                </div>

                <div className="modal-form-group-full-width">
                  <input type="text" id="username" name="username" placeholder=" " value={formData.username} onChange={handleInputChange} disabled={isLoading} />
                  <label htmlFor="username">Username</label>
                  {errors.username && <span className="field-error">{errors.username}</span>}
                </div>

                <div className="modal-form-group-full-width">
                  <input type="text" id="businessName" name="businessName" placeholder=" " value={formData.businessName} onChange={handleInputChange} disabled={isLoading} />
                  <label htmlFor="businessName">Business Name</label>
                </div>

                {authType === 'email' ? (
                  <div className="modal-form-group">
                    <input type="email" id="email" name="email" placeholder=" " value={formData.email} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="email">Email</label>
                    {errors.email && <span className="field-error">{errors.email}</span>}
                  </div>
                ) : (
                  <div className="modal-form-group">
                    <input type="tel" id="phone" name="phone" placeholder=" " value={formData.phone} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="phone">Phone Number</label>
                    {errors.phone && <span className="field-error">{errors.phone}</span>}
                  </div>
                )}

                <div className="modal-form-group">
                  <div className="password-input-wrapper">
                    <input type={showPassword ? 'text' : 'password'} id="password" name="password" placeholder=" " value={formData.password} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="password">Password</label>
                    <button type="button" className="password-toggle" onClick={() => setShowPassword(!showPassword)} disabled={isLoading}>
                      {showPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                      )}
                    </button>
                  </div>
                  {errors.password && <span className="field-error">{errors.password}</span>}
                </div>

                <div className="modal-form-group">
                  <div className="password-input-wrapper">
                    <input type={showConfirmPassword ? 'text' : 'password'} id="confirmPassword" name="confirmPassword" placeholder=" " value={formData.confirmPassword} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <button type="button" className="password-toggle" onClick={() => setShowConfirmPassword(!showConfirmPassword)} disabled={isLoading}>
                      {showConfirmPassword ? (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
                      ) : (
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                      )}
                    </button>
                  </div>
                  {errors.confirmPassword && <span className="field-error">{errors.confirmPassword}</span>}
                </div>

                <div className="form-options">
                  <div className="user-signup-terms-container">
                    <input type="checkbox" id="termsAgreementUser" name="termsAgreed" className="auth-custom-checkbox" checked={formData.termsAgreed} onChange={handleInputChange} disabled={isLoading} />
                    <label htmlFor="termsAgreementUser" className="user-signup-terms-label">I agree to the Terms of Service and Privacy Policy</label>
                  </div>
                </div>

                <button type="submit" className="submit-btn" disabled={isLoading}>
                  {isLoading ? 'Creating Account...' : 'Create Account'}
                </button>
              </form>

              <div className="form-footer">
                <p>Already have an account? <button type="button" onClick={onSwitchToLogin} className="link-btn">Sign In</button></p>
              </div>
            </div>
          </div>
        </div>

        {/* Right - Image */}
        <div className="modal-image-section">
          <img src={signupImage} alt="Sign Up" className="modal-image" />
          <div className="image-overlay">
            <div className="decorative-shape top-left-shape"></div>
            <div className="decorative-shape bottom-right-shape"></div>
            <div className="overlay-content">
              <div className="overlay-card">
                <h3>Join the Revolution!</h3>
                <p>Create your account and experience the future of hospital management.</p>
              </div>
              <div className="bottom-overlay">
                <h3>Transform Your Healthcare,<br />One Click at a Time!</h3>
                <p>Get started with HMS Platform today!</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupModal;
